import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imports_loader = _resolveComponent("imports-loader")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_import_status_icon = _resolveComponent("import-status-icon")!
  const _component_file_name_dropdown = _resolveComponent("file-name-dropdown")!
  const _component_download_file_btn = _resolveComponent("download-file-btn")!
  const _component_message = _resolveComponent("message")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_imports_loader, {
      "account-id": _ctx.accountId,
      filters: _ctx.filters,
      result: { items: _ctx.imports, total: _ctx.pagination.rowsNumber },
      onLoaded: _ctx.onLoaded
    }, null, 8, ["account-id", "filters", "result", "onLoaded"]),
    _createVNode(_component_q_table, _mergeProps({
      columns: _ctx.columns,
      rows: _ctx.imports,
      pagination: _ctx.pagination,
      "onUpdate:pagination": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pagination) = $event))
    }, _ctx.$attrs, {
      "wrap-cells": "",
      onRequest: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination = $event.pagination))
    }), {
      "body-cell-startedAt": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            (props.row.startedAt)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$filters.datetime(props.row.startedAt)), 1))
              : (_openBlock(), _createBlock(_component_q_icon, {
                  key: 1,
                  name: "fa fa-spinner fa-spin"
                }))
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-completedAt": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            (props.row.completedAt)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$filters.datetime(props.row.completedAt)), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_3, "N/A"))
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-status": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createVNode(_component_import_status_icon, {
              "post-import": props.row
            }, null, 8, ["post-import"])
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-actions": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            (props.row.fileName)
              ? (_openBlock(), _createBlock(_component_file_name_dropdown, {
                  key: 0,
                  "file-name": props.row.fileName
                }, null, 8, ["file-name"]))
              : _createCommentVNode("", true),
            _createVNode(_component_download_file_btn, {
              "post-import-id": props.row.id,
              flat: ""
            }, null, 8, ["post-import-id"])
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "no-data": _withCtx(() => [
        _createVNode(_component_message, {
          type: "info",
          class: "full-width q-my-sm"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" No post imports found. ")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 16, ["columns", "rows", "pagination"])
  ]))
}